import React from 'react';

export const ContactoComponent = () => {
  return (
    <div className='page contact-page'>
      <h1 className='heading'>¡Hablemos!</h1>

      <div className="contact-container">
        <div className="contact-info">
          <h2>Información de Contacto</h2>
          <p>Estoy disponible para nuevos proyectos, colaboraciones o simplemente para charlar sobre tecnología.</p>

          <div className="info-items">
            <div className="info-item">
              <span className="icon">📧</span>
              <div className="details">
                <span className="label">Email</span>
                <a href="mailto:michael.cuadros.cc@gmail.com">michael.cuadros.cc@gmail.com</a>
              </div>
            </div>

            <div className="info-item">
              <span className="icon">🔗</span>
              <div className="details">
                <span className="label">LinkedIn</span>
                <a href="https://www.linkedin.com/in/michael-cuadros-ccahuana/" target="_blank" rel="noopener noreferrer">in/michael-cuadros-ccahuana</a>
              </div>
            </div>

            <div className="info-item">
              <span className="icon">📍</span>
              <div className="details">
                <span className="label">Ubicación</span>
                <span>Lima, Perú</span>
              </div>
            </div>
          </div>

          <div className="whatsapp-section">
            <a
              href="https://wa.me/51982960959"
              className="whatsapp-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.432 5.631 1.433h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              Chat on WhatsApp
            </a>
          </div>
        </div>

        <form className='contact-form' action="mailto:michael_andre_525@hotmail.com">
          <div className="form-group">
            <input type='text' name="name" placeholder='Tu Nombre' required />
          </div>
          <div className="form-group">
            <input type='email' name="email" placeholder='Tu Email' required />
          </div>
          <div className="form-group">
            <input type='text' name="subject" placeholder='Asunto' required />
          </div>
          <div className="form-group">
            <textarea name="message" placeholder='¿En qué puedo ayudarte?' required />
          </div>
          <button type='submit' className="submit-btn text-white">Enviar Mensaje</button>
        </form>
      </div>
    </div>
  );
};
